import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GrantsDatashareService {

  public _GrantApplicationID = new BehaviorSubject<string>("");
  GrantApplicationID = this._GrantApplicationID.asObservable();

  public _CharityID = new BehaviorSubject<string>("");
  CharityID = this._CharityID.asObservable();

  public _CMEID = new BehaviorSubject<string>("");
  CMEID = this._CMEID.asObservable();

  public _SPONSORSHIPID = new BehaviorSubject<string>("");
  SPONSORSHIPID = this._SPONSORSHIPID.asObservable();
   public _Currency_ID = new BehaviorSubject<string>("");
   Currency_ID = this._Currency_ID.asObservable();
   
  setCurrency_ID(value: string) {
  this._Currency_ID.next(value);
  }
  setGrantApplicationID(value: string) {
    this._GrantApplicationID.next(value);
  }

  public _Application_Type_ID = new BehaviorSubject<string>("");
  Application_Type_ID = this._Application_Type_ID.asObservable();

  setApplication_Type_ID(value: string) {
    this._Application_Type_ID.next(value);
  }
   

  setCharityID(value: string) {
    this._CharityID.next(value);
  }
  setCMEID(value: string) {
    this._CMEID.next(value);
  }
  setSPONSORSHIPID(value: string) {
    this._SPONSORSHIPID.next(value);
  }
}
